module.exports = __webpack_public_path__ + "img/zhanhuidongtai.1827852f.png";